const PRODUCTS_PAGE = {
  pageTitle: {
    ja: "プロダクト | 株式会社NAPIRE",
    en: "Products | NAPIRE Inc.",
  },
  metaDescription: {
    ja: "NAPIREが手がける自社プロダクトのご紹介。おやのね、HITOHA、家電カルテ、READY CLUB、SAKEME、DAYO、CHŪN——暮らしに届くサービスを公開しています。",
    en: "Explore NAPIRE’s own products—Oyanone, HITOHA, Kaden Karte, READY CLUB, SAKEME, DAYO, and CHŪN—services built for everyday life.",
  },
  metaKeywords: {
    ja: "NAPIRE,プロダクト,おやのね,HITOHA,家電カルテ,READY CLUB,SAKEME,DAYO,CHŪN,自社サービス",
    en: "NAPIRE,products,Oyanone,HITOHA,Kaden Karte,READY CLUB,SAKEME,DAYO,CHUN,consumer apps",
  },
  heroLabel: { ja: "Products", en: "Products" },
  heroBrand: { ja: "NAPIRE", en: "NAPIRE" },
  heroTitle: {
    ja: "暮らしに届く、\n自社プロダクト。",
    en: "Products that reach\neveryday life.",
  },
  heroLead: {
    ja: "法人向けの実装力を、日常の体験へ。家族・健康・住まい・備え・好み・つながり——現場で磨いたAIとクラウドを、プロダクトとして公開しています。",
    en: "Enterprise-grade AI and cloud, shaped into everyday products—for family, health, the home, preparedness, taste, and connection.",
  },
  heroCta: { ja: "プロダクトを見る", en: "Browse products" },
  heroCta2: { ja: "お問い合わせ", en: "Contact us" },
  countLabel: { ja: "公開中のプロダクト", en: "Live products" },
  jumpLabel: { ja: "一覧", en: "Jump to" },
  visitLabel: { ja: "サイトを見る", en: "Visit site" },
  appStoreLabel: { ja: "App Store", en: "App Store" },
  googlePlayLabel: { ja: "Google Play", en: "Google Play" },
  externalHint: { ja: "外部サイトへ移動します", en: "Opens external site" },
  philosophyLabel: { ja: "Our approach", en: "Our approach" },
  philosophyTitle: {
    ja: "実装の力を、\n日常のプロダクトへ。",
    en: "Engineering strength,\nmade for daily life.",
  },
  philosophyText: {
    ja: "NAPIREは、法人向けAI・DX・クラウドの伴走で培った設計力を、自社プロダクトにもそのまま活かしています。企画から開発・運用までワンチームで手がけ、使い続けられる体験を届けます。",
    en: "The same craft we bring to enterprise AI, DX, and cloud work powers our own products—one team from concept through build and ops, focused on experiences people keep using.",
  },
  ctaTitle: {
    ja: "プロダクト連携・協業のご相談",
    en: "Partnerships & product inquiries",
  },
  ctaText: {
    ja: "掲載プロダクトへのご質問、協業、埋め込み連携など、お気軽にご連絡ください。",
    en: "Questions about these products, partnerships, or integrations—reach out anytime.",
  },
  ctaBtn: { ja: "メールで相談", en: "Email us" },
}

const PRODUCTS = [
  {
    id: "oyanone",
    theme: "oyanone",
    url: "https://oyanone.napire.co.jp/",
    ogImage: "https://oyanone.napire.co.jp/opengraph-image.jpg",
    appStoreUrl: "https://apps.apple.com/jp/app/%E3%81%8A%E3%82%84%E3%81%AE%E3%81%AD/id6794542572",
    googlePlayUrl: "https://play.google.com/store/apps/details?id=jp.oyanone.app&hl=ja",
    mark: { ja: "おやのね", en: "Oyanone" },
    category: { ja: "家族の物語", en: "Family stories" },
    name: { ja: "おやのね", en: "Oyanone" },
    tagline: {
      ja: "親の声を、家族の物語に。",
      en: "A parent’s voice, into a family story.",
    },
    desc: {
      ja: "聞いておきたかったことを、毎週ひとつ。声で答えるだけで、AIが人生の物語に整えます。広告なし・公開範囲は家族だけ。",
      en: "One weekly question. Speak the answer—AI gently shapes it into a life story. No ads; sharing stays with the family you invite.",
    },
    highlights: [
      { ja: "声でかんたん記録", en: "Voice-first recording" },
      { ja: "AIがやさしく編集", en: "Gentle AI editing" },
      { ja: "家族だけで共有", en: "Family-only sharing" },
    ],
  },
  {
    id: "hitoha",
    theme: "hitoha",
    url: "https://hitoha.napire.co.jp/",
    ogImage: "https://hitoha.napire.co.jp/og.png",
    mark: { ja: "H", en: "H" },
    category: { ja: "精子・卵子画像レビュー", en: "Sperm & oocyte review" },
    name: { ja: "HITOHA", en: "HITOHA" },
    tagline: {
      ja: "精子・卵子の画像を、AIで整理。元胚培養士に相談。",
      en: "AI organizes sperm and oocyte images—then consult an embryologist.",
    },
    desc: {
      ja: "クリニックでもらった画像の「どこを見ればいい？」を3分でレポート。見えていること・わからないこと・医師に聞く質問を整理し、必要なときは元胚培養士へ相談できます。",
      en: "Turn clinic images into a clear 3-minute report—what’s visible, what’s unknown, and questions for your doctor—with optional review by a former embryologist.",
    },
    highlights: [
      { ja: "AI観察レポート", en: "AI observation report" },
      { ja: "診察で聞く質問整理", en: "Doctor question notes" },
      { ja: "元胚培養士レビュー", en: "Embryologist review" },
    ],
  },
  {
    id: "kadenkarte",
    theme: "kaden",
    url: "https://kadenkarte.napire.co.jp/",
    ogImage: "https://kadenkarte.napire.co.jp/og.png",
    mark: { ja: "家", en: "家" },
    category: { ja: "住まい・家電", en: "Home & appliances" },
    name: { ja: "家電カルテ", en: "Kaden Karte" },
    tagline: {
      ja: "家電のこと、ぜんぶ覚えておく。",
      en: "Remember everything about your appliances.",
    },
    desc: {
      ja: "型番ラベルを撮るだけ。保証期限も、お手入れも、故障時に必要なことも、家族で共有しながら管理できます。",
      en: "Snap the model label. Warranties, care schedules, and repair essentials—managed and shared with family.",
    },
    highlights: [
      { ja: "AIラベル読取", en: "AI label scan" },
      { ja: "保証・お手入れ通知", en: "Warranty & care alerts" },
      { ja: "修理相談シート", en: "Repair consult sheets" },
    ],
  },
  {
    id: "ready",
    theme: "ready",
    url: "https://ready.napire.co.jp/",
    ogImage: "https://ready.napire.co.jp/og.png",
    mark: { ja: "R", en: "R" },
    category: { ja: "防災・備え", en: "Preparedness" },
    name: { ja: "READY CLUB", en: "READY CLUB" },
    tagline: {
      ja: "備えを、暮らしの習慣に。",
      en: "Make preparedness a living habit.",
    },
    desc: {
      ja: "わが家に必要な備蓄を診断し、期限管理・入れ替え・防災訓練まで続けられるサービス。一度買って終わりにしない防災へ。",
      en: "Diagnose what your household needs, then keep stock, expiry, restocking, and drills going—preparedness that doesn’t stop at purchase.",
    },
    highlights: [
      { ja: "家庭別の備え診断", en: "Household stock diagnosis" },
      { ja: "期限前通知", en: "Expiry reminders" },
      { ja: "ローリングストック", en: "Rolling stock support" },
    ],
  },
  {
    id: "dayo",
    theme: "dayo",
    url: "https://dayo.napire.co.jp/",
    ogImage: "https://dayo.napire.co.jp/og.png",
    mark: { ja: "D", en: "D" },
    category: { ja: "コミュニケーション", en: "Messaging" },
    name: { ja: "DAYO", en: "DAYO" },
    tagline: {
      ja: "返さなくても、つながれる。",
      en: "Stay close—without the reply pressure.",
    },
    desc: {
      ja: "メッセージの前に気配が伝わる“気配ファースト”のメッセンジャー。Pulse・AIキャッチアップ・予定整理で、つながる負担を減らします。",
      en: "A presence-first messenger—Pulse, AI catch-up, and smart plans that shrink the weight of staying in touch.",
    },
    highlights: [
      { ja: "Pulse（気配）", en: "Pulse presence" },
      { ja: "AIキャッチアップ", en: "AI catch-up" },
      { ja: "Smart Plan", en: "Smart Plan" },
    ],
  },
  {
    id: "sakeme",
    theme: "sakeme",
    url: "https://sakeme.napire.co.jp/",
    ogImage: "https://sakeme.napire.co.jp/og.png",
    mark: { ja: "●", en: "●" },
    category: { ja: "日本酒", en: "Sake" },
    name: { ja: "SAKEME", en: "SAKEME" },
    tagline: {
      ja: "ラベルを向ける。好きがわかる。",
      en: "Point at the label. Know what you like.",
    },
    desc: {
      ja: "写すだけで銘柄・評価・あなたとの相性まで。飲むほど賢くなる、日本酒パーソナルガイドです。",
      en: "Scan a label for name, ratings, and your personal match—a sake guide that gets smarter with every pour.",
    },
    highlights: [
      { ja: "ラベルスキャン", en: "Label scan" },
      { ja: "#サケ目診断", en: "Taste profiling" },
      { ja: "相性スコア", en: "Match scores" },
    ],
  },
  {
    id: "chun",
    theme: "chun",
    url: "https://chun-shochu.napire.co.jp/",
    ogImage: "https://chun-shochu.napire.co.jp/og.png",
    mark: { ja: "酎", en: "酎" },
    category: { ja: "焼酎", en: "Shochu" },
    name: { ja: "CHŪN", en: "CHŪN" },
    tagline: {
      ja: "焼酎の好み、チューニングしよう。",
      en: "Tune your shochu taste.",
    },
    desc: {
      ja: "ラベルを撮る。香りを記録する。次の一杯が見つかる。飲むほど自分の“偏愛”がわかる焼酎アプリです。",
      en: "Scan labels, log aromas, find the next glass—a shochu app that maps your personal obsessions.",
    },
    highlights: [
      { ja: "ラベルスキャン", en: "Label scan" },
      { ja: "味覚プロフィール", en: "Taste profile" },
      { ja: "今夜のペアリング", en: "Night pairing" },
    ],
  },
]

function getProducts() {
  return PRODUCTS
}
